module.exports = __webpack_public_path__ + "static/media/GPremium-brand@2x.da677603.png";